export const convertEnumerationToObject = <T extends object>(en: T): { [K in keyof T]: T[K] } => {
  return Object.keys(en).reduce((a, key) => {
    a[key as keyof T] = en[key as keyof T];
    return a;
  }, {} as { [K in keyof T]: T[K] });
};